import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PermScanWifiIcon(props: IconProps) {
    return <Icon {...props} iconKey={"perm_scan_wifi"}/>
}
